module.exports = __webpack_public_path__ + "img/617586_23304C_1B1E30_4988CF-256px.2f683544.png";